<template>
    <div class="qr-view">
        <img style="width: 200px" :src="$env.getAppLogo().logo" />
        <ActionButton
            style="margin-top: 2rem"
            label="BUTTON_BACK"
            @click="backToApp"
        />
    </div>
</template>
<script>
export default {
    methods: {
        backToApp() {
            const url = this.$env.getMainApp()
            window.location = url
        }
    }
}
</script>
<style lang="scss" scoped>
.qr-view {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
</style>
